import { render, staticRenderFns } from "./PpmChildrenInfo.vue?vue&type=template&id=4ab23cf9&scoped=true"
import script from "./PpmChildrenInfo.vue?vue&type=script&lang=ts"
export * from "./PpmChildrenInfo.vue?vue&type=script&lang=ts"
import style0 from "./PpmChildrenInfo.vue?vue&type=style&index=0&id=4ab23cf9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab23cf9",
  null
  
)

export default component.exports